<template>
  <div id="honda-sponsor">
    <div v-if="isSnecmaSafranUser">
      <strong>Call or email CFM Help desk :</strong>
      <div class="number"><strong>France: </strong>{{ cfmSponsor.snecmaInternational }}</div>
      <div class="number">
        <strong>E-mail: </strong> <a :href="'mailto:' + cfmSponsor.snecmaEmail"> {{ cfmSponsor.snecmaEmail }}</a>
      </div>
    </div>
    <div v-else>
      <strong>CFM Web Support Team</strong>
      <div class="number"><strong>US: </strong>{{ cfmSponsor.us }}</div>
      <div class="number"><strong>International: </strong>{{ cfmSponsor.international }}</div>
      <div class="number"><strong>China and Asia: </strong>{{ cfmSponsor.chinaAndAsia }}</div>
      <div class="number">
        <strong>E-mail: </strong> <a :href="'mailto:' + cfmSponsor.email"> {{ cfmSponsor.email }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cfmSponsor: {
        us: "1-877-432-3272 ",
        international: "1- 513 552 3272 ",
        chinaAndAsia: "+86 400 820 6208",
        email: "aviation.fleetsupport@ge.com",
        snecmaInternational: "+33 1 64 14 88 66",
        snecmaEmail: "cfm.csc@safrangroup.com"
      },
      isSnecmaSafranUser: false
    };
  },
  created() {
    this.isSnecmaSafranUser =
      this.$store.state.user.user.email.toLowerCase().endsWith("@safrangroup.com") ||
      this.$store.state.user.user.email.toLowerCase().endsWith("@snecma.com") ||
      this.$store.state.user.user.mdmOrgZone == "SA";
  }
};
</script>
<style lang="less" scoped>
#honda-sponsor {
  margin-top: 25px;
}
.number strong {
  color: @gray-dark;
}
</style>
